// 노출 회원등급
export default Object.freeze({
  STATUS: '노출 회원등급',

  ALL: '전체(회원+비회원)',
  ONLY_MEMBER: '회원전용(비회원 제외)',
  SPECIFIC_MEMBER: '특정회원등급',
});
